module.exports = __webpack_public_path__ + "img/7.334c9175.svg";